module.exports = __webpack_public_path__ + "static/img/bg@2x (5).213bc0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg@2x (5).jpg
// module id = zBvq
// module chunks = 14